<template id="report">
  <div>
    <ReportItem label="0,10€" :item="report.report010" vvFormScope="report010"></ReportItem>
    <ReportItem label="0,20€" :item="report.report020" vvFormScope="report020"></ReportItem>
    <ReportItem label="0,50€" :item="report.report050" vvFormScope="report050"></ReportItem>
    <ReportItem label="1,00€" :item="report.report1" vvFormScope="report1"></ReportItem>
    <ReportItem label="2,00€" :item="report.report2" vvFormScope="report2"></ReportItem>
                <h4>Obračun - kovanci: {{((report.report010.amount*report.report010.value)+
                             (report.report020.amount*report.report020.value)+
                             (report.report050.amount*report.report050.value)+
                             (report.report1.amount*report.report1.value)+
                             (report.report2.amount*report.report2.value)).toFixed(2) + "€"}}</h4>
  </div>
</template>
<script>
import ReportItem from './ReportTemplate1Item.vue'
export default {
  inject: ["$validator"],
  name: "report-component",
  template: "#report",
  props: {
    report: {
      type: Object
    },
    vvFormScope: {
      type: String
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  components: {
      ReportItem
  }
};
</script>